"use strict";
// The `/api/plan/` contract (Anthony's Plan spec, 2026-10-15; ANTHONY-PLAN-2026-10-18.md,
// task D). Rule 17: both apps read these, and mobile approves changes.
//
// The WIRE format, snake_case, exactly as `backend/apps/plan/serializers.py` sends it.
// Each interface mirrors one serializer: `Plan` + its name without "Serializer"
// (`MathLineSerializer` -> `PlanMathLine`; `PlanResponseSerializer` -> `PlanResponse`).
// `backend/tests/plan/test_plan_contract.py` fails if a field, its nullability, its
// optionality, its primitive type or a choice's values differ between the two.
//
// Mobile's apiClient camelises responses, so mobile reads these through
// `CamelCasedPropertiesDeep` (or its own mapping); web reads them as they are.
//
// Conventions:
// - Money is a decimal string to the cent ("1716.00"). Signed where a field says so:
//   Not planned yet is "-14.00" when overplanned (G9).
// - Every display line is its figures plus `sentence`, the line as drawn, built from
//   `shared/utils/planCopy.ts`. Render the sentence, or rebuild it from the parts with
//   the same helpers (large text restacks). Never compute a figure on the client.
// - Dates are ISO `YYYY-MM-DD`; `generated_at` is an ISO datetime.
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=plan.js.map